import { fetchUserResource, updateUserResource } from '@/utils/structuresHelper';
import dateStore from '@/utils/dateStore';
import moment from 'moment';


const state = {
  searchUserCollectionName: 'recsSearchParams',
  systemNameOptions: ['WREGIS', 'NAR'],
}

const getters = {
  defaultEndDate: () => dateStore.getDefaultDateLocal(),
  currentDateRangeSearchParams(state, getters) {
    const currentStartDate = state.selectedDates ? dateStore.toDateFromLocal(state.selectedDates[0]) : null;
    const currentEndDate = state.selectedDates ? dateStore.toDateFromLocal(state.selectedDates[1]) : null;
    const currentDateDiff = currentEndDate.diff(currentStartDate, 'days');
    const defaultEndDate = getters.defaultEndDate;

    // send null dateRangeDiff so that it will use default on next page reload
    const dateRangeDiff = currentDateDiff != state.defaultDateDiff ? currentDateDiff : null;
    // send null endDate so that it will use default on next page reload
    const endDate = !moment(currentEndDate).isSame(defaultEndDate, 'day') ? currentEndDate : null;
    const searchParams = {
      dateRangeDiff,
      endDate,
    }
    return searchParams;
  },
  defaultDateRange(state, getters) {
    const endDate = getters.defaultEndDate;
    const startDate = endDate.clone().subtract(state.defaultDateDiff, 'days');
    let range = [startDate, endDate];
    return range;
  },
}

const actions = {
  async getRecsSearchParams({ commit }, screen) {
    const resources = await fetchUserResource(state.searchUserCollectionName, screen);
    return resources;
  },
  async saveRecsSearchParams({ state }, params) {
    const { resource, payload } = params;
    await updateUserResource(state.searchUserCollectionName, resource, payload)
      .catch((e) => {
        console.error(e);
        this.$notify('Error saving search configurations', 'error');
      });
  },
}

export default {
  state,
  getters,
  actions,
}
